import { Component } from '@angular/core';

@Component({
  selector: 'stream-terms-of-use',
  templateUrl: './terms-of-use.component.html',
  styleUrls: ['./terms-of-use.component.less']
})
export class TermsOfUseComponent {}
